import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import AppSettings from '../types/AppSettings';
import * as NavigationStore from '../store/Navigation';

import { UserManager } from 'oidc-client';

import NavPrimary from './NavPrimary';
import NavSecondary from './NavSecondary';
import NavBreadcrumb from './NavBreadcrumb';

type NavMenuProps = {
    appSettings: AppSettings;
    userManager: UserManager;
    actions: typeof NavigationStore.actionCreators;
}

class NavMenu extends React.Component<NavMenuProps> {

    public componentDidMount() {
        this.ensureDataFetched();
    }

    public componentDidUpdate() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {
        this.props.actions.requestNavigation();
    }

    public render() {
        return (
            <React.Fragment>
                <header>
                    <NavPrimary appSettings={this.props.appSettings} userManager={this.props.userManager} />
                    <NavSecondary appSettings={this.props.appSettings} />
                </header>
                <NavBreadcrumb appSettings={this.props.appSettings} />
            </React.Fragment>
        );
    }
}

// function mapStateToProps(state: CommonAppState) {
//     return {
//         user: state.oidc.user,
//     };
// }

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, NavigationStore.actionCreators), dispatch )
    }
}

export default connect(
    null,
    mapDispatchToProps
)(NavMenu);